module.exports = __webpack_public_path__ + "static/media/Commercial-12.abca5da2.jpg";